import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import CustomButton from "../components/CustomButton";

const RejectModal = ({
  isModalVisible,
  setIsModalVisible,
  children,
  rejectHandler,
  title = "Voucher"
}) => {
  const onRequestClose = () => {
    setIsModalVisible({ ...isModalVisible, isOpen: false });
  };

  const rejectHan = (val) => {
    return rejectHandler(val);
  };
  // useEffect(() => {
  //   setError(false);
  //   setComment("")
  // }, [])

  const [comment, setComment] = useState("");
  const [error, setError] = useState(false);
  return (
    <div className="flex justify-center items-center w-full">
      <Modal
        isOpen={isModalVisible.isOpen}
        onRequestClose={onRequestClose}
        style={{
          content: {
            display: "flex",
            justifyContent: "center",
            // alignItems: 'center',
            borderRadius: "1rem",
            background: "#fff",
            padding: "1.5rem",
            // margin: "8rem 20rem",
            width: "30%",
            position: "relative",
          },
          overlay: {
            background: "#000000d6",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1
          },
        }}
      >
        {/* <div className="text-[2rem] text-[red] absolute top-[-4.5rem] right-[0px]">
        Close <span className="text-[2.9rem]">[x]</span>
      </div> */}
        <div className="w-full">
          {/* Header */}
          <div className="flex justify-between relative w-[100%] text-2xl font-semibold">
            Reject {title}
            <div
              className="text-3xl cursor-pointer text-red-500 ml-4"
              onClick={() => setIsModalVisible(false)}
            >
              [x]
            </div>
          </div>
          <div className="mt-4">
            <div>WRITE REASON</div>
            <textarea
              className="h-40 w-full border text-2xl mt-2 p-2"
              onChange={(e) => {
                setComment(e.target.value);
                setError(false);
              }}
            />
            {error && (
              <span className="text-red-500 text-xl">
                {"Please write comments before reject"}
              </span>
            )}
          </div>
          <div className="w-full flex justify-end">
            <CustomButton
              title="Rejected"
              wrapperClassName="!px-10 mt-6"
              style={{
                background: "white",
                color: "red",
                border: "1px solid red",
              }}
              onClick={() => {
                const { data = [] } = isModalVisible || {};
                if (comment.length > 0) {
                  rejectHan({ data: data, comment: comment });
                } else {
                  setError(true);
                }
              }}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default RejectModal;
